module.exports = __webpack_public_path__ + "img/kiparenko.9b731418.png";